import React from "react";
import { ComposableCdpAccordion, SecurityFeatures } from "components/content";
import { SolidPlate, type SolidPlateProps } from "ui/plates";

type ComposableCdpFeaturesPlateProps = {
  theme?: SolidPlateProps["theme"];
  bgColor: SolidPlateProps["bgColor"];
  spotlightColor?: SolidPlateProps["spotlightColor"];
  title?: string;
  description?: string;
};

/**
 * Combines the `ComposableCdpAccordion` and `SecurityFeatures` component on a solid plate for a
 * complete overview of the benefits of Composable CDPs.
 */
export function ComposableCdpFeaturesPlate({
  theme = "light",
  bgColor,
  spotlightColor,
  title,
  description,
}: ComposableCdpFeaturesPlateProps) {
  return (
    <SolidPlate theme={theme} bgColor={bgColor} spotlightColor={spotlightColor}>
      <ComposableCdpAccordion
        theme={theme}
        sectionTitle={title}
        sectionDescription={description}
        mt={{ base: "smallest", md: "biggest" }}
      />

      <SecurityFeatures noContainerPx theme={theme} themeBgColor={bgColor} my="0" mt={{ base: "huge", md: "huger" }} />
    </SolidPlate>
  );
}
